import Icon from 'v2/components/Icon';
import * as SC from './styles';
import ButtonBase from 'v2/components/UI/ButtonBase';
import { IModalConfirmDeleteProps } from './types';
import Text from 'v2/components/UI/Text';
import Box from 'v2/components/UI/Box';
import HashLoading from 'v2/components/UI/Loading/Hash';

const ModalConfirmDelete: React.FC<IModalConfirmDeleteProps> = ({
  isOpen,
  file,
  isLoadingDeleteFiles,
  onClose,
  onDelete,
}) => {
  const handleDownloadDocument = () => {
    if (file.url) {
      window.open(file.url, '_blank');
      return;
    }
  };

  return (
    <SC.Overlay isOpen={isOpen}>
      <SC.Background />
      <SC.ModalContent onClick={(e) => e.stopPropagation()}>
        <ButtonBase
          onClick={onClose}
          alignItems="center"
          justifyContent="center"
          position="absolute"
          right={10}
          top={10}
        >
          <Icon iconName="CloseOutlined" htmlColor="#005f47" />
        </ButtonBase>

        <Box flexDirection="column" gap={20} padding={30}>
          <Box>
            <Text color="#005f47" fontWeight={700} fontSize={22}>
              Tem certeza que deseja deletar este arquivo?
            </Text>
          </Box>

          <Box
            background={'#cccccc50'}
            padding={20}
            borderRadius={12}
            gap={10}
            flexDirection="column"
          >
            <Text color="#005f47" fontWeight={600}>
              {file.title}
            </Text>

            <Text>{file.description}</Text>

            <Box
              gap={2}
              background={'#005f4720'}
              padding={5}
              borderRadius={8}
              width={'max-content'}
            >
              <Text color="#002fff" fontSize={12} fontWeight={500}>
                Categoria:
              </Text>
              <Text color="#002fff" fontSize={12} fontWeight={500}>
                {file.category}
              </Text>
            </Box>

            <Box width={'100%'} alignItems="center">
              <ButtonBase
                alignItems="center"
                justifyContent="center"
                gap={10}
                background={'#b7ffbd80'}
                borderRadius={8}
                padding={10}
                width={'100%'}
                onClick={handleDownloadDocument}
              >
                <Icon
                  iconName="CloudDownloadOutlined"
                  htmlColor="#005F47"
                  size={20}
                />
                <Text fontSize={14} color="#005F47" fontWeight={700}>
                  Baixar arquivo antes de excluir
                </Text>
              </ButtonBase>
            </Box>
          </Box>

          <Box>
            <Text
              color="#c00000"
              fontSize={18}
              fontWeight={700}
              fontStyle="italic"
            >
              *Este arquivo não poderá ser recuperado após a exclusão.
            </Text>
          </Box>

          <Box gap={8} flexDirection="column">
            <ButtonBase
              onClick={onDelete}
              alignItems="center"
              justifyContent="center"
              background={isLoadingDeleteFiles ? '#ccc' : '#c00000'}
              borderRadius={8}
              padding={14}
              width="100%"
            >
              {isLoadingDeleteFiles ? (
                <HashLoading size={18} />
              ) : (
                <Text fontSize={14} color="#fff" fontWeight={700}>
                  Deletar arquivo
                </Text>
              )}
            </ButtonBase>

            <ButtonBase
              onClick={onClose}
              alignItems="center"
              justifyContent="center"
              width="100%"
              padding={8}
            >
              <Text fontSize={14} color="#c00000" fontWeight={700}>
                Cancelar
              </Text>
            </ButtonBase>
          </Box>
        </Box>
      </SC.ModalContent>
    </SC.Overlay>
  );
};

export default ModalConfirmDelete;
